let emptyState = null;
let welcomeState = null;
let sendOtpState = null;
let cardsState = null;
let emptyCardsState = null;
let pinState = null;
let thanksState = null;


emptyState = {},
welcomeState =  {
  app:{      
    stage:'WELCOME',
    error : null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:null
  },
  card : {
    requestedLast4Digits:'',
    offlineToken:'',
    pin:'',
    percent: 100,
    time:0,
    cards:[  ]

  }
}


sendOtpState =  {
  app:{      
    stage:'SEND_OTP',
    error : null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:null
  },
  card : {
    requestedLast4Digits:'',
    offlineToken:'',
    pin:'',
    percent: 100,
    time:0,
    cards:[  ]

  }
}


cardsState =  {
  app:{      
      stage: 'CARDS',
      error: null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:"sdfsdfsdfsdfsd345345345"
  },
  card : {
    requestedLast4Digits:'6533',
    offlineToken:'',
    pin:'',
    percent: 100,
    time:0,
    cards:[
    {
      "customerFirstName":"דר עדה",
      "customerLastName":"בן משה",
      "last4Digits":"6533",
      "cardBrand":"ויזה",
      "cardType":"זהב",
      "retrievalStatus":"",
      "retrievalType":1
    },
    {
      "customerFirstName":"עדה",
      "customerLastName":"בן משה",
      "last4Digits":"3917",
      "cardBrand":"דינרס",
      "cardType":"פלטינום",
      "retrievalStatus":"אין באפשרותינו לאחזר באתר, עליך לקבל מעטפית",
      "retrievalType":2
    },
    {
      "customerFirstName":"יחיאל",
      "customerLastName":"בן משה",
      "last4Digits":"8236",
      "cardBrand":"ויזה",
      "cardType":"בינלאומי",
      "retrievalStatus":"לא ניתן לשחזר כלל",
      "retrievalType":3
    }
  ]


  }
}


emptyCardsState =  {
  app:{      
    stage:'CARDS',
    error : null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:"sdfsdfsdfsdfsd345345345"
  },
  card : {
    requestedLast4Digits:'',
    offlineToken:'',
    pin:'',
    percent: 100,
    time:0,
    cards:[]
  }
}

pinState =  {
  app:{      
    stage:'PIN',
    error : null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:"sdfsdfsdfsdfsd345345345"
  },
  card : {
    requestedLast4Digits:'',
    offlineToken:'',
    pin:'1648',
    percent: 100,
    time:0,
    cards:[]
  }
}


thanksState =  {
  app:{      
    stage:'THANK_YOU',
    error : null,
    message:null,
    isLoading:false,
    isMenuOpen:false,
    canLogout : false
  },
  otp: {
    idNum:'',
    last4Digits:'',
    phone:'',
    otpCode:'',
    token:""
  },
  card : {
    requestedLast4Digits:'',
    offlineToken:'',
    pin:'',
    percent: 100,
    time:0,
    cards:[]
  }
}

export const initialState = emptyState;


// WEBPACK FOOTER //
// ./src/state.js